import * as React from 'react';
import { NavLink } from 'react-router-dom';

import classNames from 'classnames';

import { ITabItemInternalProps } from './types';

import * as s from './TabItem.scss';

export const TabItemCommon = (props: ITabItemInternalProps) => {
	const {
		onClick,
		active,
		className,
		title,
	} = props;

	return <span
		onClick={onClick}
		className={classNames(
			s.container,
			{ [s.active]: active },
			className,
		)}
	>
		{title}
	</span>;
};

export const TabItemLink = (props: ITabItemInternalProps) => {
	const {
		onClick,
		url,
		className,
		title,
	} = props;

	return React.createElement(NavLink, {
		exact: true,
		onClick: onClick,
		to: url,
		className: classNames(s.container, className),
		activeClassName: s.active,
	}, title);
};

export const TabItemHeader = (props: ITabItemInternalProps) => {
	const {
		className,
		title,
		active,
	} = props;

	return <h1
		className={classNames(
			s.container,
			className,
			{ ['active']: active },
		)}
	>
		{title}
	</h1>;
};

export const TabItem = (props: ITabItemInternalProps) => {
	const {
		url,
		active,
	} = props;

	return Boolean(url)
		? (active ? <TabItemHeader {...props}/> : <TabItemLink {...props}/>)
		: <TabItemCommon {...props}/>;
};
